import {
  AuthenticationStore,
  IAuthenticatedUser,
} from "@model/Authentication.model";
import { RootState } from "../Store/Store";
import { useDispatch, useSelector } from "react-redux";
import { loginUserAction } from "./LoginUserAction";
import { useCallback } from "react";
import { logoutUserAction } from "./LogoutUserAction";

const userAuthenticationSelector = (state: RootState) =>
  state.userAuthenticationReducer;

export const UserAuthenticationStoreImplementation =
  (): AuthenticationStore => {
    const dispatch = useDispatch();
    const authenticatedUser = useSelector<RootState, IAuthenticatedUser | null>(
      userAuthenticationSelector
    );

    const logUserIn = useCallback(
      (state: IAuthenticatedUser) => loginUserAction(state)(dispatch),
      [dispatch]
    );

    const logUserOut = useCallback(
      () => logoutUserAction()(dispatch),
      [dispatch]
    );

    return {
      authenticationState: authenticatedUser || null,
      logUserIn,
      logUserOut,
    };
  };
